
/**
 * 토픽 상세 정보
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfThreesevenDetails = {
  description?: string;
};
